import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Paper,
  Container,
} from "@mui/material";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import { fetchUserData } from "../services/userService";
import Nanny from "./Nanny";
import Aboutme from "./Aboutme";
import Cityuser from "./Cityuser";
import Qualifications from "./Qualifications";
import Experience from "./Experience";
import Languages from "./Languages";
import Endprofile from "./Endprofile";

const steps = [
  { label: "Dane personalne", component: (reload) => <Aboutme /> },
  {
    label: "Co mogę zrobić?",
    component: (reload) => <Nanny reloadList={reload} />,
  },
  { label: "Gdzie mogę pracować?", component: (reload) => <Cityuser /> },
  {
    label: "Kwalifikacje i uprawnienia",
    component: (reload) => <Qualifications reloadList={reload} />,
  },
  { label: "Doświadczenie", component: (reload) => <Experience /> },
  { label: "Języki obce", component: (reload) => <Languages /> },
  { label: "Zakończenie edycji", component: (reload) => <Endprofile /> },
];

export default function ProfileStepper() {
  const [activeStep, setActiveStep] = useState(-1);
  const [reloadList, setReloadList] = useState(0);
  const { userData, setUserData } = useContext(UserDataContext);

  const storageKey = userData?.userId
    ? `selectedTabTasks_${userData.userId}`
    : null;

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const userDataAnswer = await fetchUserData();
        if (userDataAnswer && userDataAnswer.userId) {
          setUserData(userDataAnswer);
        } else {
        }
      } catch (error) {
        console.error("Error during user verification:", error);
      } finally {
      }
    };
    verifyUser();
  }, [setUserData]);

  useEffect(() => {
    if (!storageKey) return;

    const savedStep = localStorage.getItem(storageKey);

    if (savedStep !== null) {
      setActiveStep(parseInt(savedStep, 10));
    }
  }, [storageKey]);

  useEffect(() => {
    if (!userData?.userId) return;

    const savedStep = localStorage.getItem(
      `selectedTabTasks_${userData.userId}`,
    );

    if (savedStep !== null) {
      setActiveStep(parseInt(savedStep, 10));
    }
  }, [userData]);

  const handleNext = () => {
    const nextStep = activeStep + 1;
    setActiveStep(nextStep);
    if (storageKey) {
      localStorage.setItem(storageKey, nextStep.toString());
    }
    setReloadList((prev) => prev + 1);
  };

  const handleBack = () => {
    const prevStep = activeStep - 1;
    setActiveStep(prevStep);
  };

  const handleStepClick = (stepIndex) => {
    const newStep = activeStep === stepIndex ? -1 : stepIndex;
    setActiveStep(newStep);
  };

  useEffect(() => {
    if (!storageKey) return;

    localStorage.setItem(storageKey, activeStep.toString());
  }, [activeStep, storageKey]);

  if (userData === undefined) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (userData) {
    return (
      <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh", pb: 5 }}>
        <VN userData={userData} />

        <Container className="mt-4">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Typography variant="h5" fontWeight="700">
              Edycja profilu opiekunki
            </Typography>
            <Button
              component={Link}
              to={`/portfolio/${userData.userId}`}
              variant="contained"
              color="success"
            >
              Podgląd profilu
            </Button>
          </Box>

          <Paper
            elevation={3}
            sx={{ p: { xs: 2, md: 4 }, borderRadius: "15px" }}
          >
            <Stepper activeStep={activeStep} orientation="vertical" nonLinear>
              {steps.map((step, index) => (
                <Step key={step.label} expanded={activeStep === index}>
                  <StepLabel
                    onClick={() => handleStepClick(index)}
                    style={{ cursor: "pointer" }}
                    sx={{
                      py: 1,
                      "& .MuiStepLabel-label": {
                        fontSize: "1.1rem",
                        color:
                          activeStep === index ? "primary.main" : "inherit",
                      },
                    }}
                  >
                    <Typography
                      fontWeight={activeStep === index ? "bold" : "normal"}
                    >
                      {step.label}
                    </Typography>
                  </StepLabel>
                  <StepContent>
                    <Box sx={{ mt: 2, mb: 2 }}>
                      {step.component(reloadList)}
                    </Box>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Paper>
        </Container>
      </Box>
    );
  }
}
